const DEFAULT_ALERT_TYPE = 'unknown';
const DEFAULT_ALERT_MESSAGE = 'Alert received';
const DEFAULT_DEVICE_SERIAL = 'unknown-device';

function toObject(value) {
  return value && typeof value === 'object' ? value : null;
}

function toNonEmptyString(value) {
  if (value === null || value === undefined) return '';
  const text = String(value).trim();
  return text;
}

function resolveDeviceSerial(rawAlert) {
  if (typeof rawAlert === 'string') {
    const serial = toNonEmptyString(rawAlert);
    return serial || DEFAULT_DEVICE_SERIAL;
  }

  const alert = toObject(rawAlert);
  if (!alert) return DEFAULT_DEVICE_SERIAL;

  return (
    toNonEmptyString(alert.deviceSerial) ||
    toNonEmptyString(alert.serialNumber) ||
    toNonEmptyString(alert.serial) ||
    toNonEmptyString(alert.originator) ||
    toNonEmptyString(alert?.device?.serialNumber) ||
    toNonEmptyString(alert?.device?.deviceSerial) ||
    DEFAULT_DEVICE_SERIAL
  );
}

export function normalizeAlert(rawAlert, now = new Date()) {
  const deviceSerial = resolveDeviceSerial(rawAlert);
  const fallbackTimestamp = now.toISOString();

  if (typeof rawAlert === 'string') {
    return {
      id: `${deviceSerial}-${fallbackTimestamp}-${DEFAULT_ALERT_TYPE}`,
      _id: undefined,
      deviceSerial,
      type: DEFAULT_ALERT_TYPE,
      message: DEFAULT_ALERT_MESSAGE,
      createdAt: fallbackTimestamp,
      timestamp: fallbackTimestamp,
    };
  }

  const alert = toObject(rawAlert);
  if (!alert) {
    return {
      id: `${deviceSerial}-${fallbackTimestamp}-${DEFAULT_ALERT_TYPE}`,
      _id: undefined,
      deviceSerial,
      type: DEFAULT_ALERT_TYPE,
      message: DEFAULT_ALERT_MESSAGE,
      createdAt: fallbackTimestamp,
      timestamp: fallbackTimestamp,
    };
  }

  const type =
    toNonEmptyString(alert.type) ||
    toNonEmptyString(alert.severity) ||
    toNonEmptyString(alert.eventType) ||
    DEFAULT_ALERT_TYPE;
  const message =
    toNonEmptyString(alert.message) ||
    toNonEmptyString(alert.description) ||
    toNonEmptyString(alert.details) ||
    DEFAULT_ALERT_MESSAGE;
  const createdAt =
    toNonEmptyString(alert.createdAt) ||
    toNonEmptyString(alert.timestamp) ||
    toNonEmptyString(alert.time) ||
    toNonEmptyString(alert.date) ||
    fallbackTimestamp;
  const id =
    toNonEmptyString(alert._id) ||
    toNonEmptyString(alert.id) ||
    `${deviceSerial}-${createdAt}-${type}`;

  return {
    ...alert,
    id,
    _id: alert._id,
    deviceSerial,
    type,
    message,
    createdAt,
    timestamp: toNonEmptyString(alert.timestamp) || createdAt,
  };
}

export default normalizeAlert;
